import { render, staticRenderFns } from "./attendanceAddressBook.vue?vue&type=template&id=0828ad46&scoped=true"
import script from "./attendanceAddressBook.vue?vue&type=script&lang=js"
export * from "./attendanceAddressBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0828ad46",
  null
  
)

export default component.exports